<template>
	<div class="storage-map-view" ref="parent" :style="{ gridTemplateColumns: edit ? '200px 1fr' : '1fr' }">
		<div class="inspector" v-if="edit && !oSpot && !oUnit && !oLine" :style="{ gridTemplateRows: 'auto 1fr auto' }">
			<div class="title">Lokation</div>
			<div class="fields">
				<div>
					<div class="label">Længde *</div>
					<input class="data" v-model="location.height" />
				</div>
				<div>
					<div class="label">Bredde *</div>
					<input class="data" v-model="location.width" />
				</div>
			</div>
			<div class="buttons">
				<div @click="onCreateWall">Opret væg</div>
				<div @click="onCreateSpot">Opret plads</div>
			</div>
		</div>
		<div class="inspector" v-if="edit && oSpot" :style="{ gridTemplateRows: 'auto 1fr' }">
			<div class="title">Plads</div>
			<div class="fields">
				<div>
					<div class="label">Label *</div>
					<input class="data" v-model="oSpot.label" />
				</div>
				<div>
					<div class="label">Venstre *</div>
					<input class="data" v-model="oSpot.x" />
				</div>
				<div>
					<div class="label">Top *</div>
					<input class="data" v-model="oSpot.y" />
				</div>
				<div>
					<div class="label">Længde *</div>
					<input class="data" v-model="oSpot.height" />
				</div>
				<div>
					<div class="label">Bredde *</div>
					<input class="data" v-model="oSpot.width" />
				</div>
				<div>
					<div class="label">Type *</div>
					<select class="data" v-model="oSpot.type">
						<option value="area">PLADS</option>
						<option value="filo">FILO</option>
					</select>
				</div>
				<div>
					<div class="label">Kapacitet</div>
					<input class="data" v-model="oSpot.capacity" />
				</div>
				<div>
					<div class="label">Afhente *</div>
					<select class="data" v-model="oSpot.pickup">
						<option value="false">Nej</option>
						<option value="true">Ja</option>
					</select>
				</div>
				<div>
					<div class="label">Aflevere *</div>
					<select class="data" v-model="oSpot.dropoff">
						<option value="false">Nej</option>
						<option value="true">Ja</option>
					</select>
				</div>
				<div>
					<div class="label">Fyldte *</div>
					<select class="data" v-model="oSpot.filled">
						<option value="true">Ja</option>
						<option value="false">Nej</option>
					</select>
				</div>
				<div>
					<div class="label">Tomme *</div>
					<select class="data" v-model="oSpot.empty">
						<option value="true">Ja</option>
						<option value="false">Nej</option>
					</select>
				</div>
				<div>
					<div class="label">Instruktioner</div>
					<input class="data" v-model="oSpot.instructions" />
				</div>
				<div>
					<div class="label">Farve [hex]</div>
					<input class="data" v-model="oSpot.color" />
				</div>
			</div>
			<div class="buttons">
				<div @click="onCopySpot">Kopier</div>
			</div>
		</div>
		<div class="inspector" v-if="edit && oLine" :style="{ gridTemplateRows: 'auto 1fr' }">
			<div class="title">Væg</div>
			<div class="fields">
				<div>
					<div class="label">X1 *</div>
					<input class="data" v-model="oLine[0][0]" />
				</div>
				<div>
					<div class="label">Y1 *</div>
					<input class="data" v-model="oLine[0][1]" />
				</div>
				<div>
					<div class="label">X2 *</div>
					<input class="data" v-model="oLine[1][0]" />
				</div>
				<div>
					<div class="label">Y2 *</div>
					<input class="data" v-model="oLine[1][1]" />
				</div>
			</div>
		</div>
		<svg ref="svg" width="100%" height="100%" :viewBox="_view_box" v-for="(floor, i) in _floors" :key="i" @mousedown="onDeselect($event)" @touchstart.prevent="onDeselect($event)" xmlns="http://www.w3.org/2000/svg" @mousemove="move($event)" @touchmove="move($event)" @mouseup="endDrag($event)" @touchend.prevent="endDrag($event)">
			<!-- PLOT -->
			<rect v-if="edit" :x="0" :y="0" :width="location.width" :height="location.height" :style="{
				fill: 'yellow', 
				stroke: 'yellow',
				'fill-opacity': 0,
				'stroke-opacity': 1,
				'stroke-width': 50, 
				pointerEvents: 'none'
			}" />
			
			<!-- DRAW WALL -->
			<line v-if="mode == 'wall' && wall.length == 1" :x1="wall[0][0]" :y1="wall[0][1]" :x2="posX" :y2="posY" style="stroke: #ccc; stroke-width: 300;" />

			<!-- WALLS -->
			<line v-for="(wall, j) in location.walls" :key="'wall' + j" :x1="wall[0][0]" :y1="wall[0][1]" :x2="wall[1][0]" :y2="wall[1][1]" :style="{
				stroke: edit && oLine && oLine[0][0] == wall[0][0] && oLine[0][1] == wall[0][1] && oLine[1][0] == wall[1][0] && oLine[1][1] == wall[1][1] ? '#f00' : '#ccc',
				strokeWidth: 300
			}" @touchstart.stop.prevent="onLineClick($event, wall, 'touch')" @mousedown.stop="onLineClick($event, wall, 'click')" />

			<!-- SPOTS -->
			<drop tag="svg" @drop="(type, data) => $emit('spotDrop', spot, type, data)" :accepts="['store', 'storage', 'unit']" v-for="(spot, j) in floor.spots" :key="'spot' + j" :x="spot.x - (spot.width / 2)" :y="spot.y - (spot.height / 2)" :width="spot.width" :height="spot.height">
				<rect :class="{
					spot: true,
					drop: dragObj !== null,
					hover: spot.id == hoverId
				}" @touchstart.stop.prevent="onSpotClick($event, spot, 'touch')" @mousedown.stop="onSpotClick($event, spot, 'click')" x="0" y="0" width="100%" height="100%" @mouseenter="enterSpot(spot)" @mouseleave="leaveSpot()" :style="{
					fill: spot._embedded.storage.length > 0 ? 'blue' : (!spot.color ? '#ccc' : spot.color), 
					stroke: ((edit && oSpot && oSpot.id == spot.id) || (!edit && openSpot && openSpot.id == spot.id)) ? 'red' : '#ccc', 
					'stroke-width': 50, 
					'fill-opacity': 0.2,
					'stroke-opacity': 1,
					cursor: 'pointer'
				}" />
				<text v-if="spot.capacity && !edit" text-anchor="end" :x="spot.width" :y="600" style="font-size: 600; pointer-events: none;">{{ spot._embedded.units.length }} / {{ spot.capacity }}</text>
				<text v-if="spot.capacity && edit" text-anchor="end" :x="spot.width" :y="600" style="font-size: 600; pointer-events: none;">{{ spot.capacity }}</text>
				<text text-anchor="begin" :x="0" :y="600" style="font-size: 600; pointer-events: none;">{{ spot.label }}</text>

				<!-- UNITS -->
				<drop tag="svg" @drop="(type, data) => $emit('unitDrop', unit, type, data)" :accepts="['store', 'storage']" v-for="(unit, k) in edit ? [] : spot._embedded.units" :key="'unit' + k" :x="spot.type == 'filo' ? 100 : 100 + (Math.floor(k / 3) * (4000 + 100))" :y="(spot.height) - ((k % Math.floor(spot.height / (700 + 100)) + 1) * (700 + 100))" :width="spot.type == 'filo' ? spot.width - 200 : 4000" :height="700">
					<rect @touchstart.stop.prevent="onUnitClick($event, unit, 'touch', spot)" @mousedown.stop="onUnitClick($event, unit, 'click', spot)" x="0" y="0" width="100%" height="100%" :style="{
						fill: unit._embedded.storage.length > 0 ? '#CCCCFF' : 'white', 
						stroke: (edit && oUnit && oUnit.id == unit.id) || (!edit && openUnit && openUnit.id == unit.id) ? 'red' : '#ccc', 
						'stroke-width': 50,
						'fill-opacity': 1,
						'stroke-opacity': 1,
						cursor: 'pointer'
					}" />
					<text text-anchor="start" alignment-baseline="middle" :x="200" :y="350" style="font-size: 500; pointer-events: none;">{{ unit.full_name }}</text>
				</drop>	
			</drop>

			<!-- DRAG UNIT -->
			<rect v-if="dragging && openUnit" :x="dragX - (1200 / 2)" :y="dragY - (dragH / 2)" :width="1200" :height="dragH" :style="{
				fill: '#f00', 
				stroke: '#f00', 
				'stroke-width': 50,
				'fill-opacity': 1,
				'stroke-opacity': 1,
				cursor: 'grab',
				pointerEvents: 'none'
			}" />
		</svg>
		<div v-if="_guide != ''" class="guide">{{ _guide }}</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				copySpot: null,
				floor: 0,
				width: 100,
				height: 100,
				oUnit: null,
				oSpot: null,
				oLine: null,
				onResize: function () {
					const r = this.$refs.parent.getBoundingClientRect();

					
				},
				mode: null,
				wall: [],
				posX: 0,
				posY: 0,
				dragging: false,
				startPosX: 0,
				startPosY: 0,
				biasPosX: 0,
				biasPosY: 0,
				bufPosX: 0,
				bufPosY: 0,
				dragX: 0,
				dragY: 0,
				dragW: 0,
				dragH: 0,
				dragObj: null,
				hoverId: null
			};
		},
		props: {
			edit: {
				type: Boolean,
				default: false
			},
			location: {
				type: Object,
				default() {
					return null;
				}
			},
			openSpot: {
				type: Object,
				default() {
					return null
				}
			},
			openUnit: {
				type: Object,
				default() {
					return null
				}
			}
		},
		methods: {
			onCopySpot() {
				
				this.copySpot = this.oSpot;
				this.mode = 'newspot';
			},
			enterSpot(spot) {
				
				this.hoverId = spot.id;
			},
			leaveSpot() {
				
				this.hoverId = null;
			},

			async del() {
				

				// Wall
				if (this.oLine !== null) {
					const w1 = this.oLine;
					var w2;

					

					for (var i = 0; i < this.location.walls.length; ++i) {
						w2 = this.location.walls[i];

						if (w1[0][0] == w2[0][0] && w1[0][1] == w2[0][1] && w1[1][0] == w2[1][0] && w1[1][1] == w2[1][1]) {
							
							this.location.walls.splice(i, 1);
							return;
						}
					}
				}

				// Spot
				if (this.oSpot !== null) {
					

					await this.axios.delete(`/warehouse/spots/${this.oSpot.id}/`);
					this.oSpot = null;
					this.$emit('update');
				}
			},
			move(evt) {
				const p = this.getSvgPos(evt);

				this.posX = p.x;
				this.posY = p.y;

				if (this.edit && this.mode == 'spot' && this.dragging) {
					this.oSpot.x = Math.round(p.x + this.biasPosX);
					this.oSpot.y = Math.round(p.y + this.biasPosY);
				}

				if (!this.edit && this.openUnit !== null && this.dragging) {
					
					this.dragX = Math.round(p.x);
					this.dragY = Math.round(p.y);
				}
			},

			onCreateWall() {
				
				this.wall = [];
				this.mode = 'wall';
			},
			onCreateSpot() {
				
				this.mode = 'newspot';
			},

			startDrag(evt, type, spot) {
				const p = this.getSvgPos(evt);

				// Spot
				if (this.mode == 'newspot' && !this.dragging) {
					// Create spot
					

					if (this.copySpot === null) this.$emit('newspot', p);
					if (this.copySpot !== null) this.$emit('copyspot', p, this.copySpot);
				}

				
			
				this.dragging = true;

				

				this.startPosX = p.x;
				this.startPosY = p.y;

				this.dragX = Math.round(p.x);
				this.dragY = Math.round(p.y);

				if (this.edit) {
					// Wall
					if (this.mode == 'wall') {
						this.wall.push([
							Math.round(p.x),
							Math.round(p.y)
						]);
					}

					// Spot
					if (this.mode == 'spot') {
						this.biasPosX = this.oSpot.x - p.x;
						this.biasPosY = this.oSpot.y - p.y;
					}
				} else {
					if (this.openUnit !== null) {
						this.dragW = spot.width - 200;
						this.dragH = 1200;
					}
				}
			},
			endDrag(evt) {
				
				this.dragging = false;

				const p = this.getSvgPos(evt);

				if (this.edit) {
					// Wall
					if (this.mode == 'wall') {
						this.wall.push([
							Math.round(p.x),
							Math.round(p.y)
						]);

						this.location.walls.push(this.wall);
						this.wall = [];
					}
				} else {
					if (this.dragObj !== null && this.hoverId !== null) {
						for (var i = 0; i < this._spots.length; ++i) {
							if (this.hoverId == this._spots[i].id) {
								

								this.$emit("spotDrop", this._spots[i], 'unit', this.dragObj);
							}
						}
					}
				}

				this.dragObj = null;
				this.mode = null;
			},

			getSvgPos(evt) {
				// Find your root SVG element
				var svg = this.$refs.svg[0];

				// Create an SVGPoint for future math
				var pt = svg.createSVGPoint();

				pt.x = evt.clientX;
				pt.y = evt.clientY;

				return pt.matrixTransform(svg.getScreenCTM().inverse());
			},

			async onDeselect(evt) {
				
				this.oSpot = null;
				this.oUnit = null;
				this.oLine = null;
				this.$emit('onUnitClick', null);
				this.$emit('onSpotClick', null);

				this.startDrag(evt, null);
			},
			onLineClick(evt, line, type) {
				

				this.oSpot = null;
				this.oUnit = null;
				this.oLine = null;

				if (this.edit) {
					this.oLine = line; 
				}

				this.startDrag(evt, type, null);
			},
			onUnitClick(evt, unit, type, spot) {
				

				this.oSpot = null;
				this.oUnit = null;
				this.oLine = null;

				if (this.edit) {
					this.oUnit = unit;
					this.oSpot = null;
					this.$emit('onUnitClick', null);
				} else {
					this.$emit('onUnitClick', unit);
					this.dragObj = unit;
				}

				this.startDrag(evt, type, spot);
			},
			onSpotClick(evt, spot, type) {
				

				this.oSpot = null;
				this.oUnit = null;
				this.oLine = null;

				if (this.edit) {
					this.mode = 'spot';
					this.oUnit = null;
					this.oSpot = spot;
					this.$emit('onSpotClick', null);
				} else {
					this.$emit('onSpotClick', spot);
				}

				this.startDrag(evt, type);
			},

			nodes(floor) {
				return floor.nodes.reduce((acc, item) => {
					acc[item.id] = item;
					return acc;
				}, {});
			},
			walls(floor) {
				var nodes = this.nodes(floor);	

				return floor.edges.map((item) => {
					return {
						x1: nodes[item[0]].x,
						y1: nodes[item[0]].y,
						x2: nodes[item[1]].x,
						y2: nodes[item[1]].y
					};
				});
			},
			viewBox() {
				return `-1000 -1000 ${ parseInt(this.location.width) + 2000 } ${ parseInt(this.location.height) + 2000 }`;
			},
			spots(floor, idx) {
				return this._spots.filter((item) => {
					return item.floor == idx + 1;
				});
			},
			onKeyUp(evt) {
				

				if (evt.key == 'Delete') {
					this.del();
				}
			}
		},
		computed: {
			_guide() {
				if (this.mode == 'wall' && this.wall.length == 0) return 'Klik og hold mus/finger nede, hvor væggen skal starte';
				if (this.mode == 'wall' && this.wall.length == 1) return 'Slip hvor væggen skal afsluttes, længde = ' + Math.round(Math.sqrt(Math.pow(this.wall[0][0] - this.posX, 2) + Math.pow(this.wall[0][1] - this.posY, 2)));
				if (this.mode == 'spot' && this.dragging) return `Absolut position = ${ Math.round(this.oSpot.x) }, ${ Math.round(this.oSpot.y) }; Relativ position = ${ Math.round(this.posX - this.startPosX) }, ${ Math.round(this.posY - this.startPosY) }`;
				if (this.mode == 'newspot') return 'Klik hvor du vil have placeret din plads'; 

				

				return '';
			},
			_spots() {
				return this.location === null ? null : this.location._embedded.spots;
			},
			_floors() {
				if (this.location === null) return [];

				var map = Array.from(this.location.map);

				for (var i = 0; i < map.length; ++i) {
					map[i].walls 	= this.walls(map[i]);
					map[i].spots 	= this.spots(map[i], i);
				}

				

				return map;
			},
			_view_box() {
				
				return this.viewBox();
			}
		},
		created() {
			window.addEventListener('resize', this.onResize);
			window.addEventListener('keyup', this.onKeyUp);
		},
		destroyed() {
			window.removeEventListener('resize', this.onResize);
			window.removeEventListener('keyup', this.onKeyUp);
		}
	}
</script>

<style lang="scss" scoped>
	.storage-map-view {
		position: relative;
		display: grid;

		& > * {
			box-sizing: border-box;
		}

		& > .inspector {
			display: grid;
			border-right: 1px solid #cecece;

			& > .title {
				line-height: 40px;
				padding: 0 0 0 10px;
				font-weight: bold;
				border-bottom: 1px solid #cecece;
			}

			& > .fields {
				& > div {
					display: grid;
					grid-template-columns: 100px 100px;
					border-bottom: 1px solid #cecece;

					& > .label {
						padding: 0 0 0 10px;
						font-size: 12px;
						border-right: 1px solid #cecece;
						line-height: 34px;
					}

					& > .data {
						background-color: transparent;
						font-size: 12px;
						color: #999;
						padding: 0 10px 0 10px;
						line-height: 34px;
						text-indent: 0px;
					}

					& > select.data {
						margin: 0 5px 0 0;
						padding: 0 0 0 7px;

						& > option {
							font-size: 12px;
						}
					}
				}
			}

			& > .buttons {
				& > div {
					border-top: 1px solid #cecece;
					line-height: 40px;
					padding: 0 0 0 10px;
					cursor: pointer;
				}
			}
		}

		& > .guide {
			position: absolute;
			left: 210px;
			top: 10px;
			padding: 5px 10px 5px 10px;
			background-color: #ff00002d;
			color: red;
			border-radius: 3px;
			pointer-events: none;
		}

		.spot {
			pointer-events: all;
		}

		.spot.drop.hover {
			fill: red ! important;
			stroke: red ! important;
		}
	}
</style>